import ClearIcon from '@material-ui/icons/Clear';
import React, { memo } from 'react';

type Prop = {
    onClick: () => void;
    className?: string;
}

export const CloseButton = memo(function CloseButton ({ onClick, className }: Prop) {
    const klass = ['bg-transparent outline-none focus:outline-none', className].join(' ');
    return (
        <button type="button" className={klass} onClick={onClick}>
            <div className='bg-transparent text-atlantis-200 opacity-5 h-6 w-6 m-auto outline-none focus:outline-none'>
                <ClearIcon />
            </div>
        </button>
    );
});
